import { z } from 'zod'

export const formSchema = z.object({
  article_number: z.string().min(1, 'Article number is required'),
  item_name: z.string().min(1, 'Title is required'),
  item_description: z.string().min(1, 'Description is required'),
  source: z.string().min(1, 'Source is required'),
  brand_name: z.string().optional().nullable(),
  is_draft: z.boolean().optional().nullable(),
  default_print_technique: z.string().optional().nullable(),
  delivery_time: z.string().optional().nullable(),
  item_name_translations: z.string().optional().nullable(),
  item_description_translations: z.string().optional().nullable(),
  packaging_cost: z.number().optional().nullable(),
  print_codes: z.any().optional().nullable(),
  has_variants: z.boolean().optional().nullable(),
  margin: z.union([z.number(), z.string()]).refine(
    (val) => {
      const num = typeof val === 'string' ? parseFloat(val) : val
      return !isNaN(num) && num >= 0
    },
    { message: 'Margin is required' }
  ),
  moq: z.any(),
  fast_track: z.boolean().optional().nullable(),
  cost: z.union([z.number(), z.string()]).refine(
    (val) => {
      const num = typeof val === 'string' ? parseFloat(val) : val
      return !isNaN(num) && num >= 0
    },
    { message: 'Cost is required' }
  ),
  price: z.union([z.number(), z.string()]).refine(
    (val) => {
      const num = typeof val === 'string' ? parseFloat(val) : val
      return !isNaN(num) && num >= 0
    },
    { message: 'Price is required' }
  ),
  profit: z.union([z.number(), z.string()]).refine(
    (val) => {
      const num = typeof val === 'string' ? parseFloat(val) : val
      return !isNaN(num) && num >= 0
    },
    { message: 'Profit is required' }
  ),
  klayder_recommendation_text: z.string().optional().nullable(),
  klayder_recommends: z.boolean().optional().nullable(),
  related_product_ids: z.array(z.string()).optional().nullable(),
})

export type FormData = z.infer<typeof formSchema>

export interface ProductTabProps {
  productId: number
  onSaveHandlerReady?: (handler: () => void) => void
  onHasChangesChange?: (hasChanges: boolean) => void
}
